import React from 'react';

import Image from 'next/image';

import CustomIcon from '@components/utils/CustomIcon';
import { Info } from '@assets/icons';

import { BoldText, Container, Text, TextContainer } from './styled';

type EmailCheckProps = {
  my?: number;
};

const EmailCheck = ({ my }: EmailCheckProps) => {
  return (
    <Container my={my}>
      <Image
        src='/static/images/letter.webp'
        height={90}
        width={90}
        alt='E-posta Onay'
      />
      <Text isBold paddingTop={25} fontSize={16}>
        Lütfen E-postanızı kontrol ediniz.
      </Text>
      <Text paddingTop={25}>
        Üyelik aktivasyon linki e-posta adresinize başarıyla gönderildi.
      </Text>
      <Text>
        Lütfen e-posta içindeki aktivasyon linkine tıklayarak üyeliğinizi aktive
        edin.
      </Text>
      <TextContainer>
        <CustomIcon icon={Info} fontSize={16} />
        <Text fontSize={13}>
          Aktivasyon e-postası gelen kutunuzda değilse,<BoldText>spam</BoldText>
          yada <BoldText>junk</BoldText> klasörlerinizi kontrol ediniz.
        </Text>
      </TextContainer>
    </Container>
  );
};
export default EmailCheck;
